import type { BackendReadSession } from "../read/BackendReadSession";
import type { BackendWriteSession } from "../write/BackendWriteSession";

declare global {
  /**
   * This is a bit hacky, but it's the cleanest way to fix a bug that
   * seems to be triggered by a new version of Backend.ts being imported
   * while the user is still in the middle of a session. See REN-13773.
   * Note: This property should not be accesed anywhere else, only in this module!!
   */
  interface Window {
    piplanning_backendSess?: BackendReadSession & BackendWriteSession;
  }
}

/**
 * Keep a reference to the session locally and in the window object
 * (so it can be accessed by this module if it's ever re-loaded in
 * the middle of a user's session -- see REN-13773)
 */
export function saveBackendSession(session: BackendReadSession & BackendWriteSession) {
  window.piplanning_backendSess = session;
}

/**
 * If there's an existing backendSess in the window object, use it
 * (this should only be the case when a new version of Backend.ts is
 * loaded while the user is still in the middle of a session -- see
 * REN-13773)
 */
export function retrieveBackendSession() {
  return window.piplanning_backendSess;
}
